//Importación de librerias
//---------------Forseti---------------
//Catalogos
import C001TiposEstatusDeLaAudiencia from '../../../src/components/Forseti/Comun/Catalogos/001TiposEstatusDeLaAudiencia.vue'
import C002TiposPruebas from '../../../src/components/Forseti/Comun/Catalogos/002TiposPruebas.vue'
import C005TiposMarcador from '../../../src/components/Forseti/Comun/Catalogos/005TiposMarcador.vue'
import C015TiposDistorsionesDeAudio from '../../../src/components/Forseti/Comun/Catalogos/015TiposDistorsionesDeAudio.vue'


//Creamos y asignamos los datos necesarios de forseti
const forseti = [
  { Proviene: 'Forseti', Nombre: 'C001TiposEstatusDeLaAudiencia', datos: C001TiposEstatusDeLaAudiencia },
  { Proviene: 'Forseti', Nombre: 'C002TiposPruebas', datos: C002TiposPruebas },
  { Proviene: 'Forseti', Nombre: 'C005TiposMarcador', datos: C005TiposMarcador },
  { Proviene: 'Forseti', Nombre: 'C015TiposDistorsionesDeAudio', datos: C015TiposDistorsionesDeAudio }
]


//Exportamos los datos de forseti
export default forseti;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/forseti.js
// module id = null
// module chunks = 